import yup from 'common/helpers/yup'
import { TranslateFunctionType } from 'common/i18n-config'
import { mixed, number, object } from 'yup'

export const SUFFIX_TEMP_CLIENT_FIELD = '_TEMP_CLIENT_FIELD'

export const FIELD_NAMES = {
  impaired_at: 'impaired_at',
  impaired_reason: 'event_cause_id',
  impairment_method: 'impairment_method',
  impaired_amount_maximum: `impaired_amount_maximum${SUFFIX_TEMP_CLIENT_FIELD}`,
  impaired_amount: 'impaired_amount',
  impair_service_life: 'impair_service_life',
  impair_usage_period_maximum: `impair_usage_period_maximum${SUFFIX_TEMP_CLIENT_FIELD}`,
  impair_usage_period: 'impair_usage_period',
  remaining_book_value: `remaining_book_value${SUFFIX_TEMP_CLIENT_FIELD}`,
  impair_residual_value: 'impair_residual_value',
  is_partial_impairment: 'is_partial_impairment',
}

export const generatePartialImpairmentSchema = (t: TranslateFunctionType) => {
  return object().shape({
    [FIELD_NAMES.impaired_at]: mixed().required(),
    [FIELD_NAMES.impaired_reason]: number().required(''),
    [FIELD_NAMES.impaired_amount_maximum]: number().required().positive(),
    [FIELD_NAMES.impaired_amount]: number()
      .required('')
      .positive()
      .min(1, t('impaired_amount_invalid'))
      .max(yup.ref(FIELD_NAMES.impaired_amount_maximum), t('impaired_amount_invalid')),
    [FIELD_NAMES.impair_usage_period]: number()
      .nullable()
      .optional()
      .min(1)
      .max(yup.ref(FIELD_NAMES.impair_usage_period_maximum), t('impair_usage_period_invalid')),
    [FIELD_NAMES.impair_residual_value]: number()
      .nullable()
      .optional()
      .min(0)
      .max(yup.ref(FIELD_NAMES.remaining_book_value), t('impair_residual_value_invalid')),
  })
}
